module.exports = __webpack_public_path__ + "static/media/varun_kudtarkar.4992a98e.png";